module.exports = __webpack_public_path__ + "static/media/Inspiron1.343a9c65.png";